import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  ADD_SUB_PRODUCT_SUCCESS: null,
  ADD_SUB_PRODUCT_ERROR: null,
  REMOVE_SUB_PRODUCT_SUCCESS: null,
  REMOVE_SUB_PRODUCT_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export const SubProductGroupActions = Reflux.createActions([
  'getSubProductGroups',
  'deleteSubProductGroup',
  'clearToast',
  'createEmptySubProductGroup',
  'clearFormToast',
  'updateSubProductGroupField',
  'saveSubProductGroup',
  'getSubProductGroupDetails',
  'addSubProduct',
  'removeSubProduct'
])

export class SubProductGroupStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = SubProductGroupActions
    this.state = {
      status: null,
      subProductGroups: [],
      subProductGroupName: null,
      subProductGroupDetails: {
        SubProductGroupID: null,
        SubProductGroupName: '',
        removed: false
      }
    }
  }

  getSubProductGroups() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('subProductGroups/pool').then(responseJSON => {
      let nextState = {
        subProductGroups: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.subProductGroups = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  deleteSubProductGroup(id = null) {
    if (id) {
      POST('subProductGroups/removeSubProductGroup', { SubProductGroupID: id }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_ERROR })
        } else {
          this.getSubProductGroups()
        }
      })
    }
  }

  createEmptySubProductGroup() {
    this.setState({
      subProductGroupDetails: {
        SubProductGroupName: '',
        removed: false
      }
    })
  }

  clearFormToast(status) {
    status ? this.setState({ status }) : this.setState({ status: STATUS.TAKING_INPUT })
  }

  getSubProductGroupDetails(id = null) {
    if (!id) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('subProductGroups/fetch', { SubProductGroupID: id }).then(responseJSON => {
      let nextState = {
        subProductGroupDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.subProductGroupDetails = responseJSON
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  updateSubProductGroupField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'removed') {
      fieldValue = field.target.checked ? 1 : 0
    } else {
      fieldValue = field.target.value
    }
    let subProductGroupDetails = this.state.subProductGroupDetails
    subProductGroupDetails[fieldName] = fieldValue
    this.setState({ subProductGroupDetails })
  }

  saveSubProductGroup() {
    let subProductGroupDetails = this.state.subProductGroupDetails
    this.setState({ status: STATUS.IS_SAVING })
    POST('subProductGroups/replace', subProductGroupDetails).then(responseJSON => {
      if (responseJSON) {
        if (responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_ERROR })
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
    })
  }

  addSubProduct(ProductID) {
    if (this.state.subProductGroupDetails && this.state.subProductGroupDetails.SubProductGroupID) {
      POST('subProductGroups/addSubProduct', { SubProductGroupID: this.state.subProductGroupDetails.SubProductGroupID, ProductID }).then(
        responseJSON => {
          if (responseJSON) {
            if (responseJSON.error) {
              this.setState({ status: STATUS.ADD_SUB_PRODUCT_ERROR })
            } else {
              this.setState({
                status: STATUS.ADD_SUB_PRODUCT_SUCCESS,
                subProductGroupDetails: {
                  ...this.state.subProductGroupDetails,
                  subProducts: [...this.state.subProductGroupDetails.subProducts, { ProductID, elementTitle: responseJSON.elementTitle }]
                }
              })
            }
          }
        }
      )
    }
  }

  removeSubProduct(ProductID) {
    if (this.state.subProductGroupDetails && this.state.subProductGroupDetails.SubProductGroupID) {
      POST('subProductGroups/removeSubProduct', { SubProductGroupID: this.state.subProductGroupDetails.SubProductGroupID, ProductID }).then(
        responseJSON => {
          if (responseJSON) {
            if (responseJSON.error) {
              this.setState({ status: STATUS.REMOVE_SUB_PRODUCT_ERROR })
            } else {
              this.setState({
                status: STATUS.REMOVE_SUB_PRODUCT_SUCCESS,
                subProductGroupDetails: {
                  ...this.state.subProductGroupDetails,
                  subProducts: this.state.subProductGroupDetails.subProducts.filter(subProduct => subProduct.ProductID !== ProductID)
                }
              })
            }
          }
        }
      )
    }
  }
}
